import { defineMessages } from 'react-intl';

export const messages: {
	buyStandard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	maybeLater: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	subtitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'recommend-standard-over-premium.modal.title.percentage-off',
		defaultMessage:
			'Get everything you need for {percentageOff}% off with <purple>Standard</purple>',
		description:
			'The title of this upsell modal, telling users that they would save money if they bought the Standard edition.',
	},
	subtitle: {
		id: 'recommend-standard-over-premium.modal.subtitle.days-left-in-trial',
		defaultMessage:
			'Your Premium trial ends in {daysLeftInTrial, plural, one {# day} other {# days}}. With Standard, you get to keep essential features at a lower price.',
		description:
			'The subtitle of this upsell modal, reassuring users that if they bought the Standard edition, they would save money.',
	},
	buyStandard: {
		id: 'recommend-standard-over-premium.modal.buy-standard',
		defaultMessage: 'Buy Standard',
		description:
			'Label for the button that takes the user to Admin Hub to buy the Jira or Confluence Standard plans.',
	},
	maybeLater: {
		id: 'recommend-standard-over-premium.modal.maybe-later',
		defaultMessage: 'Maybe later',
		description: 'Label for the button that dismisses this upsell modal.',
	},
});
